import {
  GetOrganisationParams,
  GetOrganisationsResponse,
  OrganisationsServiceCapabilities,
} from './organisations.types'

export const organisationsService = ({
  client,
}: OrganisationsServiceCapabilities) => ({
  getOrganisations: (args: GetOrganisationParams) =>
    client.get<GetOrganisationsResponse>(`/v1/organisations`, {
      params: args,
    }),
})
